var _defs, _rect, _path, _path2, _path3, _path4, _path5, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V150H700V300H600zM0,300V400H300V0H600z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "star",
    fill: "#ffce00",
    d: "M0,-50.0808 29.4368,40.5162 -47.6297,-15.4758H47.6297L-29.4368,40.5172z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "rats",
    xlinkHref: "#star",
    transform: "rotate(36)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#00247d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 600,300M0,300 600,0",
    stroke: "#fff",
    strokeWidth: 60
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 600,300M0,300 600,0",
    stroke: "#cf142b",
    strokeWidth: 40,
    clipPath: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0V400M0,150H700",
    stroke: "#fff",
    strokeWidth: 100
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0V400M0,150H700",
    stroke: "#cf142b",
    strokeWidth: 60
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,300H600V0H1200V600H0z",
    fill: "#5b97b1"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 645.3396,
    y: 540.9936
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rats",
    x: 788.0256,
    y: 504.516
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rats",
    x: 788.0256,
    y: 382.5324
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rats",
    x: 914.0304,
    y: 473.6844
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rats",
    x: 914.0304,
    y: 208.2708
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 996.4416,
    y: 390.0456
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rats",
    x: 1019.928,
    y: 172.0776
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 1102.836,
    y: 321.5544
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 1102.836,
    y: 87.486
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.cb5b0b59c6ca0728ed1d6df2f94d820b.svg";
export { ForwardRef as ReactComponent };